import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import Payment from "@/pages/Payment";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Library from "@/pages/Library";
import Play from "@/pages/Play";
import Alignment from "@/pages/Alignment";
import MindfulArcade from "@/pages/MindfulArcade";
import Home from "@/pages/Home";
import Journey from "@/pages/Journey";
import Marketplace from "@/pages/Marketplace";
import CreateAd from "@/pages/CreateAd";
import MyAds from "@/pages/MyAds";
import AdDetail from "@/pages/AdDetail";
import GamePage from "@/pages/GamePage";
import { SkullDecor } from "@/components/SkullDecor";

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen bg-[#0A0A14] flex items-center justify-center text-[#00F0FF] font-['VT323',monospace] text-2xl tracking-widest">LOADING…</div>;
  if (!user) return <Navigate to="/auth" replace />;
  return children;
};

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const AppRoutes = () => {
  const location = useLocation();
  // Process the Google OAuth callback (session_id in URL fragment) before anything else.
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/auth" element={<Auth />} />
        <Route path="/home" element={<Protected><Home /></Protected>} />
        <Route path="/journey" element={<Protected><Journey /></Protected>} />
        <Route path="/market" element={<Marketplace />} />
        <Route path="/market/new" element={<Protected><CreateAd /></Protected>} />
        <Route path="/market/mine" element={<Protected><MyAds /></Protected>} />
        <Route path="/market/:id" element={<AdDetail />} />
        <Route path="/mindful" element={<Protected><MindfulArcade /></Protected>} />
        <Route path="/games/:slug" element={<GamePage />} />
        <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
        <Route path="/pay/:tier" element={<Protected><Payment /></Protected>} />
        <Route path="/payment/success" element={<Protected><PaymentSuccess /></Protected>} />
        <Route path="/games" element={<Protected><Library /></Protected>} />
        <Route path="/alignment" element={<Protected><Alignment /></Protected>} />
        <Route path="/play/:gameId" element={<Protected><Play /></Protected>} />
      </Routes>
    </>
  );
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <SkullDecor />
        </BrowserRouter>
        <Toaster position="top-right" theme="dark" />
      </AuthProvider>
    </div>
  );
}

export default App;
